import React, { useRef, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { AppContext, DispatchContext } from '../AppContext';
import Image from 'material-ui-image'
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from '@material-ui/icons/Warning';
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import Service from "../services/service";
import * as actions from '../actions/actions';
import Skeleton from '@material-ui/lab/Skeleton';
import { config, getParaLevelString, resolveNotificationMessage } from '../helpers/constants';
import ReactTooltip from "react-tooltip";
import { useStaticState } from '@material-ui/pickers';
import Draggable from 'react-draggable';
import Paper from '@material-ui/core/Paper';
import CopyToClipboard from 'react-copy-to-clipboard';
import CanvasCompare from './CanvasCompare';
import IconLabel from './IconLabel';
import Link from "@material-ui/core/Link";


const variants = ['body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1', 'body1'];

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
});

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    dialog_container: {
        overflowY: 'hidden !important'
    },
    dialog: {
        height: '80vh',
    },
    container_text: {
        paddingTop: '15px',
        overflow: "hidden",
        flex: "1 auto",
    },
    content_body: {
        wordBreak: 'break-word',
        height: "100%",
        overflowY: "scroll",
        whiteSpace: (state) => { return (state.ui.showLinebreaks) ? "pre-line" : ""; }
    },
    graph_container: {
        flex: "0 auto",
    },
    image_container: {
        borderBottom: '1px solid #085eec',
        marginLeft: "auto",
        marginRight: "auto",
        //width: "100%"
    },
    button_block: {
        minWidth: '120px',
    },
    button_icon: {
        paddingLeft: '5px',
    },
    image_style: {
        width: '100%',
        height: 'auto',
        position: 'inherit'
    }
}));

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography noWrap variant="h6" >{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        paddingTop: 0,
        flex: "1 1 auto",
        flexDirection: "column",
        display: "flex",
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

let section1 = null;
let section2 = null;
export default function CompareSource(props) {
    const { open, onHandleClose, reloadReport, noRating } = props;
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const dispatch = useContext(DispatchContext);


    const handleClose = () => {
        onHandleClose(false)
    }

    const handleChangedRatingButton = (updateSoruceDetail) => {
        let data = []
        data.push({
            ...updateSoruceDetail,
            sid: state.activeSource.Id
        })

        Service.updateSources(data, state.activeReport.Id, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.openToast({ type: "success", message: s.notificationMessage.sourceUpdated, status: true }));
                reloadReport();
                onHandleClose(false);
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
            }
        });
    };

    // Scoll page While hover source detail and source list
    const scrollToContent = (sourceParentId, sourceElementId, targetParentId, targetElementId) => {
        
        var targetElem = document.getElementById(targetElementId);
        var sourceElem = document.getElementById(sourceElementId);
        var targetWindow = document.getElementById(targetParentId);
        var sourceWindow = document.getElementById(sourceParentId);
        if (targetElem && sourceElem && targetWindow && sourceWindow) {

            var sourcePos = sourceElem.offsetTop - sourceWindow.scrollTop;
            targetWindow.scrollTo({ top: targetElem.offsetTop - sourcePos, behavior: 'smooth'});

            // attention: React will break down one <span> in multiple ones
            setTimeout(() => {
                var allTargetElems = document.querySelectorAll("[id="+targetElementId+"]");
                allTargetElems.forEach(element => {
                    element.style.transition = 'opacity .4s ease-in';
                    element.style.opacity = '0.5';
                    setTimeout(() => {
                        if (element.style)
                        element.style.opacity = '1';
                    }, 500);
                });
            }, 0);
        }
    }
    
    return (
        <div style={{ position: "relative" }}>
            <Dialog PaperComponent={PaperComponent} maxWidth='md' classes={{ paper: classes.dialog }} fullWidth={true} disableBackdropClick={false} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title" onClose={handleClose}>
                    {state.activeSource.Title}
                </DialogTitle>

                <DialogContent dividers className={classes.dialog_container}>
                    <Grid container id="customized-dialog-header" className={classes.graph_container}>
                        <Grid alignContent="center" container className={classes.image_container}>
                            {!state.loadingSidebySideCompare ?
                                <Skeleton animation="wave" width={'100%'} height={118} /> :
                                <CanvasCompare width="920px" height="120px"/>
                            }
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} className={classes.container_text}>
                        <Grid id="Text1" className={classes.content_body} item xs={6} >
                        {state.loadingSidebySideCompare && <Typography noWrap paragraph variant="h6">{state.sourceMarkup.Text1.Name}</Typography>}
                            {!state.loadingSidebySideCompare && variants.map((variant, i) => (
                                <Typography key={i} variant={variant}>
                                    {<Skeleton animation="wave" width={'100%'} />}
                                </Typography>
                            ))}
                            {state.sourceMarkup && state.sourceMarkup.Text1 &&
                                state.sourceMarkup.Text1.Markup.map((source, index) => {
                                    if (source.PIdx == null) 
                                        return source.T; 
                                    var color = state.ui.colors[source.PIdx % 10];
                                    return (
                                        <span id={'Text1_' + source.PIdx} onClick={() => scrollToContent('Text1', 'Text1_' + source.PIdx, 'Text2', 'Text2_' + source.PIdx)} data-for="compareTT" data-tip={source.Sim ? getParaLevelString(source.Sim1 || source.Sim, s.paraphraseLevel) : null} ref={section2} key={index} style={{ backgroundColor: color, cursor: "pointer" }}>
                                            {(source.Sub.length > 0) && source.Sub.map((sub) => {
                                             return (sub.MIdx == null) ? 
                                                <span style={{ fontWeight: 100}}>{sub.T}</span>
                                                :
                                                <span style={{ fontWeight: 500}}>{sub.T}</span>})}
                                             {(source.Sub.length == 0) && <span>{source.T}</span>}   
                                        </span>
                                    );
                                })}
                        </Grid>
                        <Grid id="Text2" className={classes.content_body} item xs={6} >
                            {state.loadingSidebySideCompare && <Typography noWrap paragraph variant="h6">{state.sourceMarkup.Text2.Name}</Typography>}
                            {variants.map((variant, i) => (
                                <Typography key={i} variant={variant}>
                                    {!state.loadingSidebySideCompare && <Skeleton animation="wave" width={'100%'} />}
                                </Typography>
                            ))}
                            {state.sourceMarkup && state.sourceMarkup.Text2 && state.sourceMarkup.Text2.IsFingerprint && 
                                <IconLabel type="info" label={s.libraryText.isFingerprint} />
                                }
                            
                            {state.sourceMarkup && state.sourceMarkup.Text2 && !state.sourceMarkup.Text2.IsFingerprint &&
                                state.sourceMarkup.Text2.Markup.map((source, index) => {
                                    if (source.PIdx == null) return source.T;
                                    var color = state.ui.colors[source.PIdx % 10];
                                    return (
                                        <span id={'Text2_' + source.PIdx} onClick={() => scrollToContent('Text2', 'Text2_' + source.PIdx, 'Text1', 'Text1_' + source.PIdx)} data-for="compareTT" data-tip={source.Sim ? getParaLevelString(source.Sim2 || source.Sim, s.paraphraseLevel) : null} ref={section2} key={index} style={{ backgroundColor: color, cursor: "pointer" }}>
                                            {(source.Sub.length > 0) && source.Sub.map((sub) => {
                                             return (sub.MIdx == null) ? 
                                                <span style={{ fontWeight: 100}}>{sub.T}</span>
                                                :
                                                <span style={{ fontWeight: 500}}>{sub.T}</span>})}
                                             {(source.Sub.length == 0) && <span>{source.T}</span>}   
                                        </span>
                                    );
                                })}
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    {!noRating &&
                        <>
                            <Button className={classes.button_block} disabled={state.activeReport.ReadOnly || (state.activeSource.Accepted && state.activeSource.Used)} onClick={() => handleChangedRatingButton(
                                { acc: 1 }
                            )} variant="contained" color="primary">
                                <CheckCircleIcon /> <span className={classes.button_icon}>{s.accept}</span>
                            </Button>
                            <Button className={classes.button_block} disabled={state.activeReport.ReadOnly || (state.activeSource.Excluded)} onClick={() => handleChangedRatingButton(
                                { exc: 1 }
                            )} variant="contained" color="primary">
                                <NotInterestedIcon /> <span className={classes.button_icon}> {s.exclude} </span>
                            </Button>
                            <Button className={classes.button_block} disabled={state.activeReport.ReadOnly || (!state.activeSource.Accepted && state.activeSource.Used)} onClick={() => handleChangedRatingButton(
                                { acc: 0 }
                            )} variant="contained" color="primary">
                                <WarningIcon /> <span className={classes.button_icon}>{s.suspicious}</span>
                            </Button>
                        </>
                    }
                    <Button className={classes.button_block} onClick={handleClose} variant="outlined" color="primary">
                        {s.cancel}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}